module.exports = __webpack_public_path__ + "static/img/point-bg@m.a5158d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/point-bg@m.png
// module id = raZ2
// module chunks = 0